import React, { useEffect, useRef } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ images, index, onClose, onIndex }) {
  const startX = useRef(null);
  useEffect(() => {
    if (index == null) return;
    const h = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onIndex((index + 1) % images.length);
      if (e.key === "ArrowLeft") onIndex((index - 1 + images.length) % images.length);
    };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [index, images, onClose, onIndex]);

  if (index == null || !images?.length) return null;
  const prev = (e) => { e.stopPropagation(); onIndex((index - 1 + images.length) % images.length); };
  const next = (e) => { e.stopPropagation(); onIndex((index + 1) % images.length); };
  const btn = { position: "absolute", top: "50%", transform: "translateY(-50%)", background: "rgba(255,255,255,.14)", border: "none", color: "#fff", borderRadius: "50%", width: 46, height: 46, cursor: "pointer", display: "grid", placeItems: "center" };

  return (
    <div
      onClick={onClose}
      data-testid="lightbox"
      onTouchStart={(e) => { startX.current = e.touches[0].clientX; }}
      onTouchEnd={(e) => { if (startX.current == null) return; const dx = e.changedTouches[0].clientX - startX.current; if (dx > 45) prev(e); else if (dx < -45) next(e); startX.current = null; }}
      style={{ position: "fixed", inset: 0, zIndex: 200, background: "rgba(20,17,14,.95)", display: "grid", placeItems: "center" }}
    >
      <button onClick={(e) => { e.stopPropagation(); onClose(); }} data-testid="lightbox-close" style={{ position: "absolute", top: 18, right: 18, background: "none", border: "none", color: "#fff", cursor: "pointer" }}><X size={28} /></button>
      {images.length > 1 && <button onClick={prev} data-testid="lightbox-prev" style={{ ...btn, left: 12 }}><ChevronLeft size={24} /></button>}
      <img src={images[index]} alt="" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "92vw", maxHeight: "86vh", objectFit: "contain", borderRadius: 2 }} />
      {images.length > 1 && <button onClick={next} data-testid="lightbox-next" style={{ ...btn, right: 12 }}><ChevronRight size={24} /></button>}
      <div style={{ position: "absolute", bottom: 20, left: 0, right: 0, textAlign: "center", color: "#fff", fontSize: 13, opacity: 0.8 }}>{index + 1} / {images.length}</div>
    </div>
  );
}
